var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "19399522241579780463 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.1067 51.5905L55.25 30.5185V12.4097H34.5166V31.6161H42.4304L34.5166 51.5905H45.1067ZM37.6122 28.5681V15.4593H52.1527V29.8321L43.1454 48.5409H39.0471L46.9576 28.5697H37.6122V28.5681Z",
    fill: "#E9B22C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.3401 51.5905L30.4834 30.5185V12.4097H9.75V31.6161H17.6654L9.75 51.5905H20.3401ZM12.8456 28.5681V15.4593H27.3861V29.8321L18.3804 48.5409H14.2821L22.1926 28.5697H12.8456V28.5681Z",
    fill: "#E9B22C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.3f8c4907ef114009248fd087db44ba57.svg";
export { ForwardRef as ReactComponent };